module.exports = __webpack_public_path__ + "img/jesusc.4c267dca.png";